import { createSlice } from "@reduxjs/toolkit"
import { DEFAULT_CURRENCY_ABREVIATURE } from "features/Contactos/constants/index"
import { DEFAULT_PENDING_VALIDATIONS } from "features/Validaciones/constants"
import {
  changeEstadoAlbaran,
  changeEstadoFactura,
  changeEstadoPedido,
  changeEstadoPresupuesto,
  changeMultipleAlbaranesEstados,
  changeMultipleFacturasEstados,
  changeMultiplePedidosEstados,
  changeMultiplePresupuestosEstados,
  getDocumentoPendienteValidacionById,
  getDocumentosPendientesValidacion,
  getFactura,
  getFacturaRecurrenteById,
  getFacturasRecurrentes,
  getFacturasRecurrentesHistorico,
  getFlujosTesoreriaFromFacturas,
} from "./documentosExtraActions"

export const documentoSlice = createSlice({
  name: "documento",
  initialState: {
    selectedDocumento: null,
    multipleDocumentosSelected: [],
    isRevisionModalSingleShowing: false,
    isRevisionModalMultipleShowing: false,
    isDownloadDocumentoModalShowing: false,
    isVerDocumentoModalShowing: false,
    isCreatingEstadoDocumento: false,
    successEstadoDocumento: false,
    documentosPendientes: 0,
    currency: DEFAULT_CURRENCY_ABREVIATURE,
    validaciones: [],
    validacionesPendientes: DEFAULT_PENDING_VALIDATIONS,
    validacionesLoading: false,
    validacion: {},
    facturasRecurrentes: [],
    facturasRecurrentesLoading: false,
    facturaRecurrente: {},
    facturaRecurrenteLoading: false,
    facturasRecurrentesHistoricas: [],
    facturasRecurrentesHistoricasLoading: false,
    documentoComercialId: null,
    ficherosAdjuntosRecurrentes: [],
    factura: {},
    facturaLoading: false,
    flujosTesoreriaFactura: [],
    flujosTesoreriaFacturaLoading: false,
  },
  reducers: {
    showDocumentoToEdit(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.selectedDocumento = payload
      state.isRevisionModalSingleShowing = true
    },
    setSelectedMultipleDocumentos(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.multipleDocumentosSelected = payload
    },
    showRevisionModalSingle(state: $TSMigrationFixMe) {
      state.isRevisionModalSingleShowing = true
    },
    showRevisionModalMultiple(state: $TSMigrationFixMe) {
      state.isRevisionModalMultipleShowing = true
    },
    showDownloadDocumentoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.selectedDocumento = payload
      state.isDownloadDocumentoModalShowing = true
    },
    uploadValueDocumentoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.selectedDocumento = payload
    },
    showVerDocumentoModal(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.selectedDocumento = payload
      state.isVerDocumentoModalShowing = true
    },
    hideVerDocumentoModal(state: $TSMigrationFixMe) {
      state.selectedDocumento = null
      state.isVerDocumentoModalShowing = false
    },

    hideDownloadDocumentoModal(state: $TSMigrationFixMe) {
      state.selectedDocumento = null
      state.isDownloadDocumentoModalShowing = false
    },
    hideRevisionModalSingle(state: $TSMigrationFixMe) {
      state.isRevisionModalSingleShowing = false
    },
    hideRevisionMultipleModalSingle(state: $TSMigrationFixMe) {
      state.isRevisionModalMultipleShowing = false
    },
    clearDocumentosState(state: $TSMigrationFixMe) {
      state.selectedDocumento = null
      state.multipleDocumentosSelected = []
    },
    setCurrency(state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) {
      state.currency = payload
    },
    clearFacturaRecurrenteState(state: $TSMigrationFixMe) {
      state.facturaRecurrente = {}
    },
    clearFacturaState(state: $TSMigrationFixMe) {
      state.factura = {}
    },
    setPendingValidationsCount(
      state: $TSMigrationFixMe,
      { payload }: $TSMigrationFixMe
    ) {
      state.validacionesPendientes = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeEstadoFactura.pending, (state) => {
        state.isCreatingEstadoDocumento = true
        state.successEstadoDocumento = false
      })
      .addCase(changeEstadoFactura.rejected, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.successEstadoDocumento = false
      })
      .addCase(changeEstadoFactura.fulfilled, (state) => {
        state.isCreatingEstadoDocumento = false
        state.selectedDocumento = null
        state.isRevisionModalSingleShowing = false
        state.successEstadoDocumento = true
      })
      .addCase(changeEstadoPresupuesto.pending, (state) => {
        state.selectedDocumento = null
        state.isCreatingEstadoDocumento = true
        state.successEstadoDocumento = false
      })
      .addCase(changeEstadoPresupuesto.rejected, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.successEstadoDocumento = false
      })
      .addCase(changeEstadoPresupuesto.fulfilled, (state) => {
        state.isCreatingEstadoDocumento = false
        state.selectedDocumento = null
        state.isRevisionModalSingleShowing = false
        state.successEstadoDocumento = true
      })
      .addCase(changeEstadoPedido.pending, (state) => {
        state.selectedDocumento = null
        state.isCreatingEstadoDocumento = true
        state.successEstadoDocumento = false
      })
      .addCase(changeEstadoPedido.rejected, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.successEstadoDocumento = false
      })
      .addCase(changeEstadoPedido.fulfilled, (state) => {
        state.isCreatingEstadoDocumento = false
        state.selectedDocumento = null
        state.isRevisionModalSingleShowing = false
        state.successEstadoDocumento = true
      })
      .addCase(changeEstadoAlbaran.pending, (state) => {
        state.selectedDocumento = null
        state.isCreatingEstadoDocumento = true
        state.successEstadoDocumento = false
      })
      .addCase(changeEstadoAlbaran.rejected, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.successEstadoDocumento = false
      })
      .addCase(changeEstadoAlbaran.fulfilled, (state) => {
        state.isCreatingEstadoDocumento = false
        state.selectedDocumento = null
        state.isRevisionModalSingleShowing = false
        state.successEstadoDocumento = true
      })
      .addCase(changeMultipleFacturasEstados.pending, (state) => {
        state.isCreatingEstadoDocumento = true
        state.successEstadoDocumento = false
      })
      .addCase(changeMultipleFacturasEstados.rejected, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.successEstadoDocumento = false
      })
      .addCase(changeMultipleFacturasEstados.fulfilled, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.isRevisionModalMultipleShowing = false
        state.successEstadoDocumento = true
      })
      .addCase(changeMultiplePresupuestosEstados.pending, (state) => {
        state.isCreatingEstadoDocumento = true
        state.successEstadoDocumento = false
      })
      .addCase(changeMultiplePresupuestosEstados.rejected, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.successEstadoDocumento = false
      })
      .addCase(changeMultiplePresupuestosEstados.fulfilled, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.isRevisionModalMultipleShowing = false
        state.successEstadoDocumento = true
      })
      .addCase(changeMultiplePedidosEstados.pending, (state) => {
        state.isCreatingEstadoDocumento = true
        state.successEstadoDocumento = false
      })
      .addCase(changeMultiplePedidosEstados.rejected, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.successEstadoDocumento = false
      })
      .addCase(changeMultiplePedidosEstados.fulfilled, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.isRevisionModalMultipleShowing = false
        state.successEstadoDocumento = true
      })
      .addCase(changeMultipleAlbaranesEstados.pending, (state) => {
        state.isCreatingEstadoDocumento = true
        state.successEstadoDocumento = false
      })
      .addCase(changeMultipleAlbaranesEstados.rejected, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.successEstadoDocumento = false
      })
      .addCase(changeMultipleAlbaranesEstados.fulfilled, (state) => {
        state.multipleDocumentosSelected = []
        state.isCreatingEstadoDocumento = false
        state.isRevisionModalMultipleShowing = false
        state.successEstadoDocumento = true
      })
      .addCase(getDocumentosPendientesValidacion.pending, (state) => {
        state.validacionesLoading = true
      })
      .addCase(
        getDocumentosPendientesValidacion.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.validaciones = payload
          state.validacionesLoading = false
        }
      )
      .addCase(
        getDocumentosPendientesValidacion.rejected,
        (state: $TSMigrationFixMe) => {
          state.validaciones = []
          state.validacionesLoading = false
        }
      )
      .addCase(
        getDocumentoPendienteValidacionById.pending,
        (state: $TSMigrationFixMe) => {
          state.validacionLoading = true
        }
      )
      .addCase(
        getDocumentoPendienteValidacionById.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.validacion = payload
          state.validacionLoading = false
        }
      )
      .addCase(
        getDocumentoPendienteValidacionById.rejected,
        (state: $TSMigrationFixMe) => {
          state.validacion = {}
          state.validacionLoading = false
        }
      )
      .addCase(getFacturasRecurrentes.pending, (state) => {
        state.facturasRecurrentesLoading = true
      })
      .addCase(
        getFacturasRecurrentes.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.facturasRecurrentes = payload
          state.facturasRecurrentesLoading = false
        }
      )
      .addCase(getFacturasRecurrentes.rejected, (state) => {
        state.facturasRecurrentes = []
        state.facturasRecurrentesLoading = false
      })
      .addCase(getFacturaRecurrenteById.pending, (state) => {
        state.facturaRecurrenteLoading = true
      })
      .addCase(
        getFacturaRecurrenteById.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.facturaRecurrente = payload
          state.facturaRecurrenteLoading = false
        }
      )
      .addCase(getFacturaRecurrenteById.rejected, (state) => {
        state.facturaRecurrente = {}
        state.facturaRecurrenteLoading = false
      })
      .addCase(getFacturasRecurrentesHistorico.pending, (state) => {
        state.facturasRecurrentesHistoricasLoading = true
      })
      .addCase(
        getFacturasRecurrentesHistorico.fulfilled,
        (state: $TSMigrationFixMe, { payload }: $TSMigrationFixMe) => {
          state.facturasRecurrentesHistoricas = payload
          state.facturasRecurrentesHistoricasLoading = false
        }
      )
      .addCase(
        getFacturasRecurrentesHistorico.rejected,
        (state: $TSMigrationFixMe) => {
          state.facturasRecurrentesHistoricas = []
          state.facturasRecurrentesHistoricasLoading = false
        }
      )
      .addCase(getFactura.pending, (state: $TSMigrationFixMe) => {
        state.facturasLoading = true
      })
      .addCase(
        getFactura.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.factura = payload
          state.facturaLoading = false
        }
      )
      .addCase(getFactura.rejected, (state) => {
        state.factura = []
        state.facturaLoading = false
      })
      .addCase(getFlujosTesoreriaFromFacturas.pending, (state) => {
        state.flujosTesoreriaFacturaLoading = true
      })
      .addCase(
        getFlujosTesoreriaFromFacturas.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.flujosTesoreriaFactura = payload
          state.flujosTesoreriaFacturaLoading = false
        }
      )
      .addCase(getFlujosTesoreriaFromFacturas.rejected, (state) => {
        state.flujosTesoreriaFactura = []
        state.flujosTesoreriaFacturaLoading = false
      })
  },
})

export const {
  showDocumentoToEdit,
  setSelectedMultipleDocumentos,
  showRevisionModalSingle,
  hideRevisionModalSingle,
  hideRevisionMultipleModalSingle,
  clearDocumentosState,
  showRevisionModalMultiple,
  showDownloadDocumentoModal,
  hideDownloadDocumentoModal,
  showVerDocumentoModal,
  hideVerDocumentoModal,
  setCurrency,
  uploadValueDocumentoModal,
  clearFacturaRecurrenteState,
  clearFacturaState,
  setPendingValidationsCount,
} = documentoSlice.actions

export {
  changeEstadoAlbaran,
  changeEstadoFactura,
  changeEstadoPedido,
  changeEstadoPresupuesto,
  changeMultipleAlbaranesEstados,
  changeMultipleFacturasEstados,
  changeMultiplePedidosEstados,
  changeMultiplePresupuestosEstados,
}

export const documentosSelector = (state: $TSMigrationFixMe) => state.documentos

export const validacionesSelector = (state: $TSMigrationFixMe) => {
  return {
    validacion: state.documentos.validacion,
  }
}

export const facturasRecurrentesSelector = (state: $TSMigrationFixMe) => {
  return {
    facturaRecurrente: state.documentos.facturaRecurrente,
    facturaRecurrenteLoading: state.documentos.facturaRecurrenteLoading,
    facturasRecurrentesHistoricas:
      state.documentos.facturasRecurrentesHistoricas,
    facturasRecurrentesHistoricasLoading:
      state.documentos.facturasRecurrentesHistoricasLoading,
  }
}
